module.exports = __webpack_public_path__ + "static/media/shutterstock_2007366620.fc0a936f.jpg";